import React from 'react';
import { BarChart2, TrafficDataCard } from '../../components';
import { Grid, Image } from 'semantic-ui-react'
const RealTimeTraffic  = () => {
    console.log("Hello Hi")
    return (
        <div>
            <TrafficDataCard/>
        </div>
    )
}

export default RealTimeTraffic;